import { Directive } from '@angular/core';
import {FormControl, NG_VALIDATORS} from "@angular/forms";

export function checkIfValidURL(url: string): boolean {
  const URL_REGEX = new RegExp(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/); //Taken from https://www.regextester.com/94502
  return URL_REGEX.test(url);
}

export function urlValidator(control: FormControl) {
  let url = control.value;


  if(url == null || url.trim() === ""){
    return null;
  }

  try {
    const u = new URL(url);
    if (!['https:', 'http:'].includes(u.protocol)) {
      return {
        invalidURL: "Invalid URL"
      }
    }
  } catch (ex) {
    return {
      invalidURL: "Invalid URL"
    }
  }

  return null;
}

@Directive({
    selector: '[urlValidator][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useValue: urlValidator, multi: true }
    ],
    standalone: false
})
export class UrlValidatorDirective {

  constructor() { }

}
